import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import APIService from "../Services/API/APIService";
import Navbar from "../Components/NavHeader";
import { toast } from "react-toastify";
import {
  Form,
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
  Message,
  Container,
  Menu,

} from "semantic-ui-react";



const Register = (props) => {
  const [loading, setLoading] = useState(false);
  const [alert,] = useState({ show: false, message: "" });

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  const schema = Yup.object().shape({
    firstname: Yup.string().required("Required"),
    lastname: Yup.string().required("Required"),
    email: Yup.string().email("Invalid Email").required("Required"),
    phoneNumber: Yup.string().required('Required').matches(phoneRegExp, 'Phone number is not valid').test('len', 'Must be between 11 to 13 characters',
      val => !val || (val && val.toString().length >= 11 && val.toString().length < 13)),
    password: Yup.string().required('Required').min(8, 'Minimium password length is 8'),
    confirmPassword: Yup.string().required('Required').oneOf([Yup.ref('password'), null], 'Passwords must match')

  });

  const newItem = {
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: ""
  };

  const _saveCustomer = async (customer) => {
    try {
      setLoading(true);
      let response = await APIService.postData(
        "/guest-house/save-customer",
        customer
      );

      if (response.success) {
        toast.success('Registration Successful')

      } else {
        toast.error('Registration Failed');
      }

      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };




  return (
    <Container  fluid  >
      <Navbar />
      {loading && (
        <Dimmer active inverted>
          <Loader> Creating Account.... </Loader>
        </Dimmer>
      )}
      <Menu size="large" widths="0" secondary >

      </Menu>

      <Grid centered >


        {alert?.show && (
          <Card centered>
            <Message positive>
              <p style={{ fontSize: '1.12em' }}>{alert.message}</p>
            </Message>
          </Card>
        )}
        <Grid.Row>
          <Card fluid >

            <Card.Content textAlign="left">
              <Formik
                enableReinitialize={true}
                initialValues={newItem}
                validationSchema={schema}
                onSubmit={(values, { resetForm }) => {
                  _saveCustomer(values);
                  resetForm();
                }}
              >
                {(props) => {
                  const {
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleSubmit,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit} loading={loading}>

                      <Form.Group widths={2}>
                        <Form.Input

                          placeholder="First Name"
                          name="firstname"
                          value={values.firstname}
                          onChange={handleChange}
                          error={touched.firstname && errors.firstname}
                        />
                        <Form.Input

                          placeholder="Last Name"
                          name="lastname"
                          value={values.lastname}
                          onChange={handleChange}
                          error={touched.lastname && errors.lastname}
                        />

                      </Form.Group>

                      <Form.Group widths={2} >
                        <Form.Input

                          placeholder="Customer Email"
                          name="email"

                          value={values.email}
                          onChange={handleChange}
                          error={touched.email && errors.email}
                        />


                        <Form.Input


                          placeholder="Customer Phone"
                          name="phoneNumber"
                          value={values.phoneNumber}
                          onChange={handleChange}
                          type={'phone'}
                          error={touched.phoneNumber && errors.phoneNumber}
                        />




                      </Form.Group>
                      <Form.Group widths={2} >

                        <Form.Input


                          placeholder="Password"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          error={touched.password && errors.password}
                          type='password'
                        />
                        <Form.Input


                          placeholder="Confirm Password"
                          name="confirmPassword"
                          value={values.confirmPassword}
                          onChange={handleChange}
                          error={touched.confirmPassword && errors.confirmPassword}
                          type='password'
                        />
                      </Form.Group>


                      
                        <Button

                          style={{ backgroundColor: '#26f09e', color: '#000000', 
                          
                           margin : 0,
                           position : 'absolute',
                           top : '115%',
                           left : '45%'
                          
                          }}
                          content="Register"
                          type="submit"
                        />
                      
                    </Form>
                  );
                }}
              </Formik>
            </Card.Content>

          </Card>
        </Grid.Row>
      </Grid>

    </Container>
  );
};

export default Register;
